import { Component, OnInit, SecurityContext } from '@angular/core'
import { HeaderComponent } from '@components/header/header.component'
import { CAcademyFormation } from '../../../interfaces/c-academy-formation'
import { ActivatedRoute, Router } from '@angular/router'
import { DatePipe, NgForOf, NgIf } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { StarsRatingComponent } from '@components/stars-rating/stars-rating.component'
import { ButtonComponent } from '@components/button/button.component'
import { CAcademyListComponent } from '@components/c-academy-list/c-academy-list.component'
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component'
import { ApiService } from '../../../services/api.service'
import { LoadingService } from '../../../services/loading.service'
import { AnalyticsService } from 'app/services/analytics.service'

@Component({
  selector: 'app-c-academy-formation',
  standalone: true,
    imports: [
        HeaderComponent,
        NgIf,
        TranslateModule,
        DatePipe,
        NgForOf,
        StarsRatingComponent,
        ButtonComponent,
        CAcademyListComponent,
        ConfirmModalComponent
    ],
  templateUrl: './c-academy-formation.component.html',
  styleUrl: './c-academy-formation.component.scss'
})
export class CAcademyFormationComponent implements OnInit{
    formation: CAcademyFormation;
    relatedFormations: CAcademyFormation[] = [];
    sanitizedFormationLink: SafeUrl;

    isConfirmFormationCompletedModalOpen: boolean = false;
    isRateFormationModalOpen: boolean = false;

    selectedRating: number = 0; // Valor por defecto para la calificación

    constructor(
        private activatedRoute: ActivatedRoute,
        private api: ApiService,
        private loading: LoadingService,
        private router: Router,
        private sanitizer: DomSanitizer,
        private analytics: AnalyticsService
    ) {
        this.activatedRoute.params.subscribe(params => {
            const formationId = params['id'];
            this.fetchFormation(formationId);
        });
    }

    ngOnInit() {
    }

    fetchFormation(formationId: string) {
        this.loading.show()
        this.api.getFormationById(formationId).subscribe(formationDetail => {
            this.formation = formationDetail.formation
            this.relatedFormations = formationDetail.relatedFormations
            this.sanitizedFormationLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.formation.formationLink) //NOSONAR
            this.loading.hide()
        })
    }


    getBrandIconSrc(brand: string) {
        brand = brand.toLowerCase();
        switch (brand) {
            case 'dekton':
                return 'assets/icons/brands/dekton-black.svg';
            case 'silestone':
                return 'assets/icons/brands/silestone-black.svg';
            case 'sensa':
                return 'assets/icons/brands/sensa-black.svg';
            case 'scalea':
                return 'assets/icons/brands/scalea-black.svg';
            case 'prexury':
                return 'assets/icons/brands/prexury-black.svg';
            default:
                return null;
        }
    }

    updateFormationAsCompleted() {
        this.analytics.trackClick('training-finished', undefined, { type: this.formation.title });

        this.loading.show();
        this.api.setFormationCompleted(this.formation.id).subscribe((response) => {
            if (response) {
            const now = new Date();
            this.formation.completedAt = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
            }
            this.loading.hide();
            this.isConfirmFormationCompletedModalOpen = false;
            this.isRateFormationModalOpen = true;
        });
    }

    cancelFormationCompletion() {
        this.analytics.trackClick('training-not-finished-yet', undefined, { type: this.formation.title });
        this.isConfirmFormationCompletedModalOpen = false;
    }


    submitRating() {
        this.loading.show()
        
        if(this.selectedRating < 1) {
            this.loading.hide();
            this.isRateFormationModalOpen = false;
            this.goBack();
            return; // No se puede enviar una calificación menor a 1
        }

        this.analytics.trackClick(`training-rate_${this.selectedRating}`, undefined, { type: this.formation.title });

        this.api.setFormationRating(this.formation.id, this.selectedRating).subscribe((response) => {
            this.loading.hide();
            this.isRateFormationModalOpen = false;
            this.goBack();
        });
    }

    goBack() {
        this.router.navigate(['c-academy'])
    }

    downloadRelatedDocument(relatedDocument: { name: string; url: string }) {
        const link = document.createElement('a');
        link.href = relatedDocument.url;
        link.target = '_blank';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
